import * as React from 'react';
import styled, { ThemeProvider, css, } from 'styled-components';
import { margin } from 'styled-system';
import { Accordion as A11yAccordion } from 'react-accessible-accordion';
import AccordionItem from './components/AccordionItem';
import { get } from '../tools/utils';
import { AccordionContext } from './AccordionContext';
const StyledA11yAccordion = styled(A11yAccordion) `
  ${({ variant, theme: { colors, space } }) => {
    switch (variant) {
        case 'CONTAINER':
            return css `
          border-radius: 4px;
          background-color: ${colors['light-gray']};
          border: 1px solid ${colors['slate-2']};
          border-bottom: ${space.none};
          box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16),
            0 5px 8px -4px rgba(0, 0, 0, 0.16);
        `;
        case 'STEPPED_PROCESS':
            return css `
          background-color: ${colors['light-gray']};
          border: 1px solid ${colors['slate-3']};
          border-top: none;
        `;
        case 'NAVIGATION':
            return css `
          background-color: ${colors.plum};

          path {
            fill: ${colors.white};
          }
        `;
        default:
            return css ``;
    }
}}
`;
const SteppedProcessAccent = styled.div `
  background-color: ${get.colors('plum')};
  height: 8px;
`;
// There is a bug in Edge where removing the 'hidden' attribute won't update
// the dom and show the previously hidden contents. Adding this style
// explicitly somehow resolves this.
const StyledAccordionItem = styled(AccordionItem) `
  && {
    [id^='accordion__panel-'][hidden] {
      display: none;
    }
  }
`;
const Accordion = ({ children, variant, className, panelsToOpenOnMount, allowMultipleExpanded = false, }) => {
    const a11yAccordionProps = Object.assign({ variant,
        className, allowZeroExpanded: true, allowMultipleExpanded }, (panelsToOpenOnMount ? { preExpanded: panelsToOpenOnMount } : {}));
    switch (variant) {
        case 'NAVIGATION':
            return (React.createElement(AccordionContext.Provider, { value: { panelsToOpenOnMount } },
                React.createElement(ThemeProvider, { theme: (parentTheme) => (Object.assign(Object.assign({}, parentTheme), { colors: Object.assign(Object.assign({}, parentTheme.colors), parentTheme.colorModes.navigationMenuTheme.colors) })) },
                    React.createElement(StyledA11yAccordion, Object.assign({}, a11yAccordionProps), children))));
        case 'STEPPED_PROCESS':
            return (React.createElement(AccordionContext.Provider, { value: { panelsToOpenOnMount } },
                React.createElement(SteppedProcessAccent, null),
                React.createElement(StyledA11yAccordion, Object.assign({}, a11yAccordionProps), children)));
        default:
            return (React.createElement(AccordionContext.Provider, { value: { panelsToOpenOnMount } },
                React.createElement(StyledA11yAccordion, Object.assign({}, a11yAccordionProps), children)));
    }
};
/**
 * @deprecated `AccordionItem` is deprecated and will be removed in v25
 */
const AccordionItemWithMarginProps = styled(StyledAccordionItem)(margin);
/**
 * @deprecated `Accordion` is deprecated and will be removed in v25
 */
const AccordionWithMarginProps = styled(Accordion)(margin);
export { AccordionItemWithMarginProps as AccordionItem, AccordionWithMarginProps as Accordion, AccordionItem as AccordionItemForProps, Accordion as AccordionForProps, };
//# sourceMappingURL=Accordion.js.map